import { FlowButtonOptions } from './ButtonOptions';

export class FlowButtons {
  next: FlowButtonOptions;
  draft?: FlowButtonOptions;
  saveTemplate?: FlowButtonOptions;
  addTemplate?: FlowButtonOptions;
  back?: FlowButtonOptions;
  isShowPay? = false;
  isShowPayLater? = false;
  isShowInitiatorAction? = false;
  isShowThirdPartyAction? = false;
  isShowOwnerAction? = false;
}
